const env = import.meta.env;

export const siteConfig = {
  contactEmail: (env.VITE_CONTACT_EMAIL ?? "").trim(),
  linkedinUrl:
    (env.VITE_LINKEDIN_URL ?? "").trim() ||
    "https://www.linkedin.com/in/daniil-gabrielyan-a30038415/",
  githubUrl: "https://github.com/DanGabArc",
  datasetUrl: "https://github.com/DanGabArc/MAVERICK-MATH-DATASET",
};

export const pilotContactUrl = siteConfig.contactEmail
  ? `mailto:${siteConfig.contactEmail}?subject=${encodeURIComponent("Keywan external pilot")}`
  : siteConfig.linkedinUrl;
